"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const CpuArchitectureService_1 = require("./CpuArchitectureService");
const apis_1 = require("./apis");
const NewFeatureSupportLevelsService = {
    getFeaturesSupportLevel(openshiftVersion, cpuArchitecture) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const cpuArch = (0, CpuArchitectureService_1.getCpuArchitecture)(cpuArchitecture);
            const { data: features } = yield apis_1.NewFeatureSupportLevelsAPI.featuresSupportLevel(openshiftVersion, cpuArch);
            return features;
        });
    },
};
exports.default = NewFeatureSupportLevelsService;
//# sourceMappingURL=NewFeatureSupportLevelsService.js.map